export const ValidationRegex = {
  email: /^([a-zA-Z0-9+_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/,
};
